import { render } from "./AddressTypeLovComponent.vue?vue&type=template&id=37d6fe0c"
import script from "./AddressTypeLovComponent.vue?vue&type=script&lang=js"
export * from "./AddressTypeLovComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__